import { isToolbarImageActive } from './ToolbarStore';

export const updateToolbarImage = (value) => isToolbarImageActive.update((oldValue) => value);
